import React from "react";
import GrowniverseLogo from "../Photos/Logo/growniverse-logo-full-bordered.svg";

const PrivacyPolicySection = () => {
  return (
    <section className="privacy-section">
      <style>
        {`
          .privacy-section {
            background-color: #000;
            color: #ccc;
            padding: 100px 20px 40px; /* ✅ extra top padding to avoid overlap */
            position: relative;
            z-index: 1;
          }

          .privacy-container {
            max-width: 900px;
            margin: 0 auto;
            position: relative;
            z-index: 2;
          }

          .privacy-title {
            color: #00f6ff;
            font-weight: 700;
            margin-bottom: 20px;
            text-align: center;
          }

          .privacy-policy h6 {
            color: #fff;
            margin-top: 25px;
            font-size: 16px;
          }

          .privacy-policy p {
            line-height: 1.6;
            font-size: 14px;
            color: #ddd;
          }

          .privacy-policy a {
            color: #00f6ff;
            text-decoration: none;
          }

          .privacy-footer {
            text-align: center;
            margin-top: 40px;
          }

          .privacy-logo {
            width: 180px;
            margin-bottom: 10px;
          }

          .privacy-tagline {
            color: #fff;
            font-weight: 600;
            letter-spacing: 1px;
          }

          /* ✅ Fix overlapping floating elements */
          header, nav, .floating-menu {
            z-index: 9999;
          }

          /* ✅ Mobile responsiveness */
          @media (max-width: 768px) {
            .privacy-section {
              padding: 80px 15px 25px;
            }

            .privacy-policy p {
              font-size: 13px;
            }

            .privacy-logo {
              width: 140px;
            }

            .privacy-title {
              font-size: 18px;
            }
          }

          @media (max-width: 480px) {
            .privacy-policy p {
              font-size: 12px;
            }

            .privacy-title {
              font-size: 16px;
            }

            .privacy-logo {
              width: 120px;
            }

            .privacy-tagline {
              font-size: 12px;
            }
          }
        `}
      </style>

      <div className="privacy-container">
        <h5 className="privacy-title">Growniverse Privacy Policy</h5>

        <div className="privacy-policy">
          <p>
            At Growniverse, we value the trust that our students place in us when they join our Universe.
            This privacy policy explains how Growniverse collects, uses, and protects the personal information of students enrolling in our courses.
          </p>

          <h6>What Personal Information We Collect</h6>
          <p>
            <b>We collect the following personal information from students:</b><br />
            1.1 Name and Email Address<br />
            1.2 Password<br />
            1.3 Payment Information<br />
            1.4 Website/Portfolio URL<br />
            1.5 IP Address<br />
          </p>

          <h6>How We Use Personal Information</h6>
          <p>
            <b>We use personal information for these purposes:</b><br />
            2.1 Course Administration<br />
            2.2 Communication<br />
            2.3 Payment Processing<br />
          </p>

          <h6>How We Protect Personal Information</h6>
          <p>
            <b>We take reasonable measures to protect personal information:</b><br />
            3.1 SSL Encryption<br />
            3.2 Firewalls and Access Controls<br />
            3.3 Data Backup and Recovery<br />
          </p>

          <h6>Sharing Personal Information</h6>
          <p>
            <b>We do not sell personal information. We may share information with service providers:</b><br />
            4.1 Payment Processors<br />
            4.2 Email Service Providers<br />
          </p>

          <h6>Student Rights</h6>
          <p>
            <b>Students have the following rights:</b><br />
            5.1 Right to Access<br />
            5.2 Right to Correct<br />
          </p>

          <h6>Changes to This Policy</h6>
          <p>
            <b>We may modify or update this privacy policy at any time. When we make changes, we will update this page.</b>
          </p>

          <h6>Contact Us</h6>
          <p>
            <b>If you have any questions, contact us at:</b><br />
            Mail us: <a href="mailto:admin@growniverse.com" target="_blank">admin@growniverse.com</a>
          </p>

          <p>
            By enrolling in Growniverse courses, students acknowledge that they have read, understood, and agree to this privacy policy.
          </p>
        </div>

        <div className="privacy-footer">
          <img src={GrowniverseLogo} alt="Growniverse" className="privacy-logo" />
          <p className="privacy-tagline">
            GROWNIVERSE<br />
            A UNIVERSE WHERE YOU GROW
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicySection;
